/**
 * AdsService — доступ к API раздела «Реклама» (/api/ads/*)
 * ==========================================================
 *
 * Спека: .claude/plans/2026-08-25-avz-ad-monetization-dashboards.md
 *
 * Все рекламные дашборды — КАЛЕНДАРНЫЕ: диапазон дат дашборда трактуется как
 * даты событий (event_date), а не как когорта регистрации. Исключение —
 * когортные вьюхи (Ad LTV, ads-only ROAS), где сервер сам берёт reg_date.
 *
 * Кэш и дедуп одновременных запросов переиспользуются из MetricsService
 * (общий клиентский TTL 30s + AbortController на группу подписчиков).
 */

import { MetricsService } from './metricsService';
import { formatDate } from './filtersService';

/**
 * Общие query-параметры рекламных эндпоинтов из фильтров дашборда.
 * @param {Object} filters - фильтры дашборда (useFilters); adsGeos — выбор стран
 *   раздела, его подмешивает useAdsWidgetData (hooks/useAdsGeo)
 * @param {Object} extra - доп. параметры конкретного виджета
 */
export function toAdsParams(filters = {}, extra = {}) {
  const { startDate, endDate } = filters.dateRange || {};
  const platform = filters.platform && filters.platform !== 'all' ? filters.platform : undefined;
  const project = filters.project && filters.project !== 'all' ? filters.project : undefined;

  return {
    dateFrom: startDate ? formatDate(startDate) : undefined,
    dateTo: endDate ? formatDate(endDate) : undefined,
    platform,
    project,
    // Сортируем: порядок кликов не должен плодить ключи клиентского кэша.
    geo: filters.adsGeos?.length ? [...filters.adsGeos].sort() : undefined,
    clientVersions: filters.clientVersions?.length ? filters.clientVersions : undefined,
    installVersions: filters.installVersions?.length ? filters.installVersions : undefined,
    ...extra
  };
}

export class AdsService {
  /**
   * GET /api/ads<path> с общими параметрами дашборда.
   * @param {string} path - путь внутри /ads, например '/health'
   * @param {Object} filters - фильтры дашборда
   * @param {Object} extra - доп. query-параметры виджета
   * @param {Object} options - { signal, force }
   */
  static get(path, filters = {}, extra = {}, options = {}) {
    return MetricsService.cachedGet(`/ads${path}`, toAdsParams(filters, extra), options);
  }

  /** GET /api/ads<path> без параметров дашборда (уже готовый набор params). */
  static getRaw(path, params = {}, options = {}) {
    return MetricsService.cachedGet(`/ads${path}`, params, options);
  }
}

export default AdsService;
